
const state = {
    costItems: [],
    carItem: [],
    selectedCostItemIndex: null,
    selectedCostItem: {},
    totalCostAmount: null,
    newCostItem: {
        id: null,
        name: null,
        remarks: null,
        amount: null
    }
}

const getters = {
    getProformaInvoiceCostItems: (state) => {
        return state.costItems
    },
    getProformaInvoiceSelectedCostItem: (state) => {
        return state.selectedCostItem
    },
    getProformaInvoiceTotalCostAmount: (state) => {
        return state.totalCostAmount
    },
    getProformaInvoiceNewCostItem: (state) => {
        return state.newCostItem
    }
}

const mutations = {
    setProformaInvoiceCostItems: (state, newItems) => {
        state.costItems = newItems.costs
        state.carItem = newItems.car
    },
    setProformaInvoiceSelectedCostItem: (state, newItem) => {
        state.selectedCostItem = newItem
    },
    setProformaInvoiceSelectedCostItemIndex: (state, newItem) => {
        state.selectedCostItemIndex = newItem
    },
    setProformaInvoiceSelectedCostItemFieldValue: (state, data) => {
        state.selectedCostItem[data.field] = data.value
    },
    setProformaInvoiceNewCostItemFieldValue: (state, data) => {
        state.newCostItem[data.field] = data.value
    },
    pushNewProformaInvoiceNewCostItem: (state) => {
        state.costItems.push(state.newCostItem)
        state.newCostItem = { id: null, name: null, remarks: null, amount: null}
    },
    setProformaInvoiceTotalCostAmount: (state) => {
        let newValue = 0
        state.costItems.forEach(function(element) {
            newValue = Number(newValue) + Number(element.amount)
        })
        /*if(state.carItem.is_usd == "1"){
            state.totalCostAmount = Math.round(newValue * Number(state.carItem.usd_rate), 2);
        }else{
            state.totalCostAmount = newValue
        }*/
        state.totalCostAmount = newValue

    },
    replaceProformaInvoiceCostItemWithSelectedCostItem: (state) => {
        state.costItems[state.selectedCostItemIndex] = state.selectedCostItem
        state.selectedCostItem = {}
    },
    removeProformaInvoiceCostItem: (state, item) => {
        state.costItems = state.costItems.filter(i => i !== item)
    }
}

const actions = {
    changeProformaInvoiceTotalCostAmount: ({ commit }) => {
        commit('setProformaInvoiceTotalCostAmount')
    },
    changeProformaInvoiceCostItems: ({ commit }, newItems) => {
        commit('setProformaInvoiceCostItems', newItems)
    },
    changeProformaInvoiceSelectedCostItem: ({ commit }, newItem) => {
        commit('setProformaInvoiceSelectedCostItem', newItem)
    },
    changeProformaInvoiceSelectedCostItemIndex: ({ commit }, newItem) => {
        commit('setProformaInvoiceSelectedCostItemIndex', newItem)
    },
    changeProformaInvoiceSelectedCostItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setProformaInvoiceSelectedCostItemFieldValue', newFieldValue)
    },
    changeProformaInvoiceNewCostItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setProformaInvoiceNewCostItemFieldValue', newFieldValue)
    },
    updateProformaInvoiceCostItem: ({ commit }) => {
        commit('replaceProformaInvoiceCostItemWithSelectedCostItem')
    },
    saveProformaInvoiceCostItem: ({ commit }) => {
        commit('pushNewProformaInvoiceNewCostItem' )
    },
    deleteProformaInvoiceCostItem: ({ commit }, item) => {
        commit('removeProformaInvoiceCostItem', item)
    }
}


export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/proformaInvoiceCostItems.js